import React, { useRef } from 'react'
import Highlighter from 'react-highlight-words'
import { searchWords } from '../../data/Constants'
import useIntersection from '../../hooks/useIntersection'



function Project({ title, description, icons, tools, bullets, iconStyle }) {
  const ref = useRef()
  useIntersection(ref, "-30px")

  return (
    <div className="project" ref={ref}>
      <div className="project-icon">
        <IconDisplayer icons={icons} iconStyle={iconStyle} />
      </div>
      <div className="project-text">
        <h2>{title} <span className="project-text-subtitle">{""}</span></h2>
        <Highlighter
          textToHighlight={tools}
          searchWords={searchWords}
        />
        <p>
          <Highlighter
            textToHighlight={description}
            searchWords={searchWords}
          />
        </p>
        <ul>
          {bullets && bullets.map((bullet, i) =>
            <li key={i}><p>
              <Highlighter
                textToHighlight={bullet}
                searchWords={searchWords}
              />
            </p></li>
          )}
        </ul>
      </div>
      {/* <div className="project-buttons">
        <button onClick={showMore}><p>Learn More</p></button>
        {secondaryLink &&
          <button className="project-buttons-secondary" onClick={showSecondary}><p>{secondaryLinkDescription}</p></button>
        }
      </div> */}
    </div>
  )
}


function IconDisplayer({ icons, iconStyle }) {
  return (
    <div className="project-icon-icon">
      <div className="project-icon-icon-wrapper make-white" style={iconStyle}>
        {icons.map((Icon, i) => <Icon key={i} />)}
      </div>
    </div>
  )
}

export default Project
